/**
 * <kj-attr-choices> — selectable product attribute chips (color, size, fabric...).
 * Clicking a chip that is already selected unselects it again.
 * If a required choice is missing when the customer adds to cart, the
 * collapsed "Select your color and size" panel opens so the prompt can show.
 */
class KjAttrChoices extends HTMLElement {
  #wasChecked = null;

  #radioFrom(target) {
    if (!(target instanceof Element)) return null;
    if (target instanceof HTMLInputElement && target.type === 'radio') return target;
    const label = target.closest('label');
    const radio = label?.querySelector('input[type="radio"]');
    return radio && this.contains(radio) ? radio : null;
  }

  #onPointerDown = (event) => {
    const radio = this.#radioFrom(event.target);
    this.#wasChecked = radio ? { radio, checked: radio.checked } : null;
  };

  #onClick = (event) => {
    const radio = this.#radioFrom(event.target);
    if (!radio || event.target !== radio) return;
    const previous = this.#wasChecked;
    this.#wasChecked = null;
    if (previous && previous.radio === radio && previous.checked) {
      radio.checked = false;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  #onInvalid = () => {
    const details = this.closest('details');
    if (details && !details.open) details.open = true;
  };

  connectedCallback() {
    this.addEventListener('pointerdown', this.#onPointerDown);
    this.addEventListener('click', this.#onClick);
    this.addEventListener('invalid', this.#onInvalid, true);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerdown', this.#onPointerDown);
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('invalid', this.#onInvalid, true);
  }
}

if (!customElements.get('kj-attr-choices')) customElements.define('kj-attr-choices', KjAttrChoices);
